/**
 * Map product WorkoutSession.status → design calendar/drawer badges.
 *
 * Design badges: scheduled | completed | missed
 * Product statuses: scheduled | in_progress | completed | skipped
 *
 * Mapping (PRD / Member Detail redesign):
 * - completed → completed
 * - skipped → missed
 * - scheduled | in_progress | anything else → scheduled
 */
export type DesignSessionBadge = 'scheduled' | 'completed' | 'missed';

export function mapSessionStatusToDesignBadge(status: string): DesignSessionBadge {
  const s = String(status || '').toLowerCase();
  if (s === 'completed') return 'completed';
  if (s === 'skipped') return 'missed';
  return 'scheduled';
}

export function designBadgeLabel(badge: DesignSessionBadge): string {
  if (badge === 'completed') return 'Completed';
  if (badge === 'missed') return 'Missed';
  return 'Scheduled';
}
